import React, { useMemo } from 'react';
import CarListPcContainer from '../../containers/carmng/CarListPcContainer';
import CarListContainer from '../../containers/carmng/CarListContainer';

const useIsMobileOS = () => {
  const isMobileOS = useMemo(() => {
    if (typeof window === 'undefined') return false;
    const ua = navigator.userAgent.toLowerCase();
    return /android|iphone|ipad|ipod/.test(ua);
  }, []);

  return isMobileOS;
};

const CarListPage = () => {
  const isMobile = useIsMobileOS();

  return (
    <>
      {isMobile ? <CarListContainer /> : <CarListPcContainer />}
    </>
  );
};

export default CarListPage;
